import React, { useEffect, useRef, useState } from 'react';
import Icon from './Icon';

// Pecas da organizacao PESSOAL das Paginas Internas (Internas.jsx guarda o estado).
// Os nomes de icone abaixo existem no componente Icon e na lista fechada do backend
// (models/SalvaInternasGrupos.js) — manter as duas listas iguais.
export const ICONES_GRUPO = ['folder', 'grid', 'chart', 'table', 'pages', 'star', 'shield', 'database', 'settings', 'send', 'key', 'lock', 'link', 'external', 'iframe', 'html', 'terminal', 'bell', 'eye', 'history'];

export const MAX_GRUPOS = 40;   // mesmo teto do backend

export const novoIdGrupo = () => 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

// Criar / renomear grupo: nome + icone. `inicial.id` presente = edicao.
export function GrupoModal({ inicial, onSalvar, onFechar }) {
    const [nome, setNome] = useState((inicial && inicial.nome) || '');
    const [icone, setIcone] = useState((inicial && inicial.icone) || 'folder');
    const campo = useRef(null);
    const editando = !!(inicial && inicial.id);
    const ok = nome.trim().length > 0;

    useEffect(() => { if (campo.current) campo.current.focus(); }, []);

    const enviar = () => { if (ok) onSalvar({ nome: nome.trim(), icone }); };

    return (
        <div className="modal-mask" onClick={onFechar}>
            <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
                <div className="modal-head">
                    <div className="eyebrow"><span className="num">+</span> {editando ? 'Editar grupo' : 'Novo grupo'}</div>
                    <button className="icon-btn" onClick={onFechar} aria-label="Fechar"><Icon name="x" size={14}/></button>
                </div>
                <div className="modal-body">
                    <div className="field">
                        <label>Nome do grupo</label>
                        <input
                            ref={campo}
                            className="input"
                            maxLength={40}
                            value={nome}
                            placeholder="Ex.: Financeiro, Lançamentos, Liga…"
                            onChange={e => setNome(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') enviar(); if (e.key === 'Escape') onFechar(); }}
                        />
                    </div>
                    <div className="field">
                        <label>Ícone</label>
                        <div className="ig-icones">
                            {ICONES_GRUPO.map(n => (
                                <button key={n} type="button" className={`ig-icone${icone === n ? ' on' : ''}`} onClick={() => setIcone(n)} title={n} aria-pressed={icone === n}>
                                    <Icon name={n} size={16}/>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="modal-foot">
                    <button className="btn ghost sm" onClick={onFechar}>Cancelar</button>
                    <button className="btn sm" disabled={!ok} onClick={enviar}>{editando ? 'Salvar' : 'Criar grupo'}</button>
                </div>
            </div>
        </div>
    );
}

// Menu "Mover para…" que abre no card. A mascara transparente fecha ao clicar fora; Esc tambem fecha.
export function MenuMover({ grupos, atual, onEscolher, onNovo, onFechar }) {
    useEffect(() => {
        const esc = e => { if (e.key === 'Escape') onFechar(); };
        document.addEventListener('keydown', esc);
        return () => document.removeEventListener('keydown', esc);
    }, [onFechar]);

    return (
        <>
            <div className="ig-menu-mask" onClick={onFechar}/>
            <div className="ig-menu" role="menu">
                <div className="ig-menu-titulo">Mover para</div>
                {grupos.map(g => (
                    <button key={g.id} role="menuitem" className={`ig-menu-item${atual === g.id ? ' on' : ''}`} onClick={() => onEscolher(g.id)}>
                        <Icon name={g.icone} size={13}/><span>{g.nome}</span>{atual === g.id && <Icon name="check" size={12}/>}
                    </button>
                ))}
                <button role="menuitem" className={`ig-menu-item${!atual ? ' on' : ''}`} onClick={() => onEscolher('')}>
                    <Icon name="x" size={13}/><span>Sem grupo</span>{!atual && <Icon name="check" size={12}/>}
                </button>
                {grupos.length < MAX_GRUPOS && (
                    <button role="menuitem" className="ig-menu-item novo" onClick={onNovo}>
                        <Icon name="plus" size={13}/><span>Novo grupo…</span>
                    </button>
                )}
            </div>
        </>
    );
}
